module.exports = __webpack_public_path__ + "img/cargalo.bd2c0ee9.png";